import { RouterModule }  from "@angular/router";
import { AccountWorkflowComponent} from "./account";
import { OrganisationWorkflowComponent} from "./organisation";
import { ApplicationAccessWorkflowComponent} from "./applicationAccess";
export const WORKFLOWROUTING = RouterModule.forChild([
  { path: "accountworkflow/:taskId", component: AccountWorkflowComponent },
  { path: "applicationaccessworkflow/:taskId", component: ApplicationAccessWorkflowComponent },
  { path: "organisationworkflow/:taskId", component: OrganisationWorkflowComponent }
]);




// WEBPACK FOOTER //
// ./src/app/modules/workflow/workflow.route.ts